// extracted by mini-css-extract-plugin
export default {"wrap":"Header_wrap__oJuCd","logo":"Header_logo__6fgAV","info":"Header_info__TYw0a","buttons":"Header_buttons__mVldB","subTitle":"Header_subTitle__6qcAv"};